import React from 'react';
import snakeCase from 'lodash/snakeCase';
// eslint-disable-next-line import/no-cycle -- TODO: Fix this the next time the file is edited.
import { ConstituentField } from '@/modules/ConstituentEditForm';
import type SearchConstituent from '@/types/api/SearchConstituent';

export type CategoryParams = Partial<ConstituentCategories & ConstituentRules>;

const useCustomFieldCategoriesAsParams = (constituent: SearchConstituent) => {
  const {
    categoryParams,
    resourceValues,
  }: {
    categoryParams: CategoryParams;
    resourceValues: string;
  } = React.useMemo(() => {
    const params = {
      [ConstituentField.CATEGORY_BOARD_MEMBER]:
        constituent[ConstituentField.CATEGORY_BOARD_MEMBER],
      [ConstituentField.CATEGORY_CORPORATION]:
        constituent[ConstituentField.CATEGORY_CORPORATION],
      [ConstituentField.CATEGORY_FOUNDATION]:
        constituent[ConstituentField.CATEGORY_FOUNDATION],
      [ConstituentField.CATEGORY_GOVERNMENT]:
        constituent[ConstituentField.CATEGORY_GOVERNMENT],
      [ConstituentField.CATEGORY_MEMBER]:
        constituent[ConstituentField.CATEGORY_MEMBER],
      [ConstituentField.CATEGORY_PARTNER]:
        constituent[ConstituentField.CATEGORY_PARTNER],
      [ConstituentField.CATEGORY_RECIPIENT]:
        constituent[ConstituentField.CATEGORY_RECIPIENT],
      [ConstituentField.CATEGORY_VOLUNTEER]:
        constituent[ConstituentField.CATEGORY_VOLUNTEER],
      [ConstituentField.IS_DONOR_RULESET]:
        constituent[ConstituentField.IS_DONOR_RULESET],
      [ConstituentField.IS_MAJOR_DONOR_RULESET]:
        constituent[ConstituentField.IS_MAJOR_DONOR_RULESET],
      [ConstituentField.IS_RECURRING_DONOR_RULESET]:
        constituent[ConstituentField.IS_RECURRING_DONOR_RULESET],
    };

    const values = Object.entries(params)
      .reduce(
        (arr, [key, value]) => (value ? [...arr, snakeCase(key)] : arr),
        ['all_constituents'],
      )
      .join(',');

    return {
      categoryParams: params,
      resourceValues: values,
    };
  }, [constituent]);
  return { categoryParams, resourceValues };
};

export default useCustomFieldCategoriesAsParams;
